<v-autocomplete
  hide-details
  density="compact"
  variant="outlined"
  label="Client"
  :items="clients"
  v-model="client"
  @update:model-value="$emit('change', $event)"
></v-autocomplete>
